/**
 * Extract a human-readable message from an unknown value caught in a catch block.
 *
 * Replaces the repeated ternary that previously appeared ~100 times across the
 * API and frontend (Wellspring review 2026-05-10, finding Q7):
 *
 *   const msg = e instanceof Error ? e.message : 'fallback';
 *
 * - If `err` is an `Error`, returns `err.message`.
 * - If a `fallback` string is provided, returns it for non-Error values.
 * - Otherwise returns `String(err)` so callers don't accidentally hide useful
 *   info from thrown strings, numbers, or POJOs.
 */
export function toErrorMessage(err: unknown, fallback?: string): string {
  if (err instanceof Error) return err.message;
  if (fallback !== undefined) return fallback;
  return String(err);
}
